export const DetailRow = ({ label, value, valueClassName = '' }) => (<div className="flex flex-row justify-between text-gray-900 border-b border-gray-200 pb-4 last:border-b-0 last:pb-0">
        {label && <h3 className="font-normal text-base flex items-center gap-1">{label}</h3>}
        <span className={`font-semibold text-base text-right ${valueClassName}`}>{value}</span>
    </div>);
